<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import CpText from '~/components/cp/CpText/CpText.vue';

  const {bm, e, em} = useCpBem('cp-category-card');

  defineProps<{
    id: string,
    image: string,
    name: string,
    horizontal?: boolean,
    large?: boolean,
  }>();
  defineEmits<{
      (e:'onselect', id: string): void
  }>();
</script>

<template>
    <NuxtLink
        :class="bm( {'large': large!,'horizontal': horizontal!})"
        data-testid="category-card"
        @click="$emit('onselect', id)"
    >
        <div :class="em('img', {'large': large! , 'horizontal': horizontal!})">
            <v-img
                :src="image.includes('cyberpuerta.mx') ? image : `https://cyberpuerta.mx${image}`"
                data-testid="category-image"
                cover
                :alt="name"
            />
        </div>
        <div :class="e('text-box')">
            <CpText
                :class="em('text', {'horizontal': horizontal!})"
                data-testid="category-title"
                variant="body-regular"
                type="primary"
            >
                {{ name }}
            </CpText>
        </div>
    </NuxtLink>
</template>

<style scoped lang="scss">
  .cp-category-card{
    display: flex;
    flex-direction: column;
    height: 104px;
    border: 1px solid var(--color-neutral-extra-light);
    border-radius: 8px;
    width: 120px;
    margin-bottom: 16px;

    &--horizontal {
      flex-direction: row;
      width: auto;
      align-items: center;
      height: 48px;
      padding: 8px 16px;
    }
    &--large {
      height: 88px;
      width: 156px;
    }
    &__img {
      height: 48px;
      width: 104px;

      &--large {
        height: 48px;
        width: 140px;
      }
      &--horizontal {
        height: 32px;
        width: 32px;
      }
    }
    &__text {
      text-align: center;
      max-height: 32px;
      &-box {
        display: flex;
        flex: 1;
        align-items: center;
      }
      &--horizontal{
        margin-left: 8px;
        text-align: left;
      }
    }
  }
</style>
